/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_Not_OfferedInputs */

const en_directory_agent_readiness_status_not_offered = /** @type {(inputs: Directory_Agent_Readiness_Status_Not_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not offered`)
};

const zh_directory_agent_readiness_status_not_offered = /** @type {(inputs: Directory_Agent_Readiness_Status_Not_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方明确不提供`)
};

/**
* | output |
* | --- |
* | "Not offered" |
*
* @param {Directory_Agent_Readiness_Status_Not_OfferedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_not_offered = /** @type {((inputs?: Directory_Agent_Readiness_Status_Not_OfferedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_Not_OfferedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_not_offered(inputs)
	return zh_directory_agent_readiness_status_not_offered(inputs)
});
export { directory_agent_readiness_status_not_offered as "directory.agent_readiness.status.not_offered" }